export default function Prose({ text = "", className = "" }) {
  const blocks = text.split(/\n\s*\n|\n(?=## )/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={`space-y-6 ${className}`} data-testid="prose-body">
      {blocks.map((b, i) => {
        if (b.startsWith("## ")) {
          const [head, ...rest] = b.split("\n");
          return (
            <div key={i} className="space-y-4 pt-4">
              <h2 className="text-2xl sm:text-3xl text-[#1f402b] tracking-tight">{head.slice(3)}</h2>
              {rest.length > 0 && <p className="text-base sm:text-lg leading-relaxed text-[#3c4a41]">{rest.join(" ")}</p>}
            </div>
          );
        }
        return <p key={i} className="text-base sm:text-lg leading-relaxed text-[#3c4a41]">{b}</p>;
      })}
    </div>
  );
}
